"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Json = require("./Json");
Object.keys(_Json).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Json[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Json[key];
    }
  });
});
var _LocalizationJson = require("./LocalizationJson");
Object.keys(_LocalizationJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LocalizationJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LocalizationJson[key];
    }
  });
});
var _OriPackageJson = require("./OriPackageJson");
Object.keys(_OriPackageJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OriPackageJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OriPackageJson[key];
    }
  });
});
var _OriTeam = require("./OriTeam");
Object.keys(_OriTeam).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OriTeam[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OriTeam[key];
    }
  });
});
var _PackageJson = require("./PackageJson");
Object.keys(_PackageJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PackageJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PackageJson[key];
    }
  });
});
var _TsconfigJson = require("./TsconfigJson");
Object.keys(_TsconfigJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TsconfigJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TsconfigJson[key];
    }
  });
});
//# sourceMappingURL=index.js.map